<div class="st-assignment-condensed-container">
    <st-icon
        *ngIf="data()"
        class="st-assignment-condensed-icon"
        [type]="data()?.PSTCoverageType"
        [data]="data()" />
    <div class="st-assignment-condensed-container-story">
        <div class="st-assignment-condensed-container-story--slug">{{ data()?.Title }}</div>
        <div
            class="st-assignment-condensed-container-story--desc"
            [class.st-topic-item-condensed-valid]="globalTablesService.FieldDefsDict[this.pstFieldNames.Description]?.Required && !data()?.Description">
            {{ assignmentDescription() }}
        </div>
    </div>
    <div class="st-assignment-condensed-container-desk">
        <span> {{ assignmentDesks() }}</span>
    </div>
    <div class="st-assignment-condensed-container-status">
        <span> {{ data()?.PSTAssignmentStatus }}</span>
    </div>
    <st-staff-id-list
        class="st-assignment-condensed-container-owners"
        [value]="data()?.PSTAssignmentOwner"
        [disabled]="isReadOnly()"
        [shouldShowAddButton]="false" />
    @if (globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.AssignmentProp) {
        <button
            mat-button
            st-click-stop-propagation
            class="st-assignment-condensed-container-approve"
            [disabled]="isReadOnly()"
            [class.st-topic-item-condensed-container-approve--active]="data()?.PSTApproved">
            <mat-icon fontSet="material-symbols-outlined">done</mat-icon>
        </button>
    }
    <button
        *ngIf="!isPublication"
        class="st-assignment-condensed-container__more"
        mat-icon-button>
        <mat-icon>more_vert</mat-icon>
    </button>
    <button
        *ngIf="isPublication"
        mat-icon-button
        class="st-assignment-condensed-container__delete"
        [disabled]="isReadOnly()"
        (click)="deletePublication($event)">
        <mat-icon>delete_outline</mat-icon>
    </button>
</div>
